module.exports = __webpack_public_path__ + "media/images/user-780a52a3688dd2fd0230fe4949982dd5.svg";